import React, {useCallback, useEffect, useState} from 'react'
import {Grid,Box} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {fetchDepartment} from '../index';
import {Sidebar} from "./Cards/Sidebar";
import {OverviewTab} from "./Tabs/OverviewTab";
import {UsersTab} from "./Tabs/UsersTab";
import {useParams} from "react-router-dom";
import {Toolbar} from "./Cards/Toolbar";
import {Breadcrumbs} from "../../../../Components";

export const View = () => {

    const {id} = useParams();
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const item = useSelector((store) => store.departments.selected);
    const [, setErrors] = useState({});
    const [, setMessage] = useState('');
    const [, setStatus] = useState('info');

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const columns = ['id', 'department_name', 'manager_id', 'is_parking', 'icon'];
        await fetchDepartment({dispatch, filters:{id, with:['manager','users'], columns}}).then((res) => {
            setIsLoading(false);
            setErrors(res.errors)
            setMessage(res.message);
            setStatus(res.status);
        });
    }, [id, dispatch]);

    useEffect(() => {
        fetchData()
    }, [fetchData]);

    const renderTabContent = () => {
        switch (tab) {
            case 0:
                return <OverviewTab isLoading={isLoading} setIsLoading={setIsLoading} />;
            case 1:
                return <UsersTab isLoading={isLoading} setIsLoading={setIsLoading} />;
            default:
                return null;
        }
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','DEPARTMENTS', item?.department_name]} />
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Sidebar isLoading={isLoading} setIsLoading={setIsLoading}/>
            </Grid>
            <Grid item xs={12} sm={6} md={8} lg={8} xl={9}>
                <Toolbar tab={tab} setTab={setTab} />
                {renderTabContent()}
            </Grid>
        </Grid>
    );
}
